module.exports = __webpack_public_path__ + "static/media/young.738686eb.png";